// extracted by mini-css-extract-plugin
export var phone = "_52-0";
export var phoneDragging = "_52-1";